<template lang="pug">
button.btn.btn-danger(
  type="button"
  :disabled="disabled"
  @click.prevent="spikeStory"
  @mousedown="hideTooltip"
  @blur="hideTooltip"
  ref="deleteButton"
  data-toggle="tooltip"
  data-container="body"
  title="Delete"
)
  i.fa.fa-trash
  span.delete-label(v-if="!hideLabel")
    |
    | Delete
</template>

<script>
export default {
  props: {
    storyId: {
      type: Number,
      required: true
    },

    storyName: {
      type: String,
      required: false
    },

    hideLabel: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    name() {
      return this.storyName || 'this story';
    }
  },

  methods: {
    hideTooltip() {
      if (this.$refs.deleteButton) {
        jQuery(this.$refs.deleteButton).tooltip('hide')
      }
    },

    spikeStory() {
      this.hideTooltip()
      if(confirm(`Sure you want to delete "${this.name}"?`)) {
        this.$store.dispatch('story/spike').then(() => {
          this.$emit('deleted')
        })
      } else {
        // User clicked Cancel, ensure tooltip is hidden and button loses focus
        if (this.$refs.deleteButton) {
          this.$refs.deleteButton.blur()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .delete-label {
    margin-left: 5px;
  }
</style>